/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { List, Popover } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { updateRoleCompositionTemplate } from "../../../../store/actions/shifts";
import { useRoleComposition } from "./useRoleComposition";
import { buildFilterDescriptions } from "./filterDescriptions";
import RoleCompositionTrigger from "./RoleCompositionTrigger";
import _ from "lodash";

const RoleComposition = (props) => {
  const { shiftRoleCompositionTemp, triggerUpdateShiftComp, showEditIcon, updateRoleOnEdit } = props;

  const rc = useRoleComposition({
    shiftRoleCompositionTemp,
    triggerUpdateShiftComp,
    showEditIcon,
    updateRoleOnEdit,
  });

  useEffect(() => {
    const handler = (e) => {
      if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
        document.getElementById("webpack-dev-server-client-overlay")?.style.setProperty("display", "none");
        document.getElementById("webpack-dev-server-client-overlay-div")?.style.setProperty("display", "none");
      }
    };
    window.addEventListener("error", handler);
    return () => window.removeEventListener("error", handler);
  }, []);

  useEffect(() => {
    rc.updateRoleCompTemplate();
  }, [shiftRoleCompositionTemp]);

  const roleCompTemp = _.cloneDeep(shiftRoleCompositionTemp);

  const roleCompositionData = useMemo(() => buildFilterDescriptions({
    roleCompTags: rc.roleCompTags,
    ageValues: rc.ageValues,           setAgeValues: rc.setAgeValues,
    weightValues: rc.weightValues,     setWeightValues: rc.setWeightValues,
    minFeet: rc.minFeet,               setMinFeet: rc.setMinFeet,
    minInches: rc.minInches,           setMinInches: rc.setMinInches,
    maxFeet: rc.maxFeet,               setMaxFeet: rc.setMaxFeet,
    maxInches: rc.maxInches,           setMaxInches: rc.setMaxInches,
    selectedGender: rc.selectedGender, setSelectedGender: rc.setSelectedGender,
    selectedEthnicity: rc.selectedEthnicity, setSelectedEthnicity: rc.setSelectedEthnicity,
    selectedEyeColor: rc.selectedEyeColor,   setSelectedEyeColor: rc.setSelectedEyeColor,
    selectedHairColor: rc.selectedHairColor, setSelectedHairColor: rc.setSelectedHairColor,
    showEditIcon,
    addTagForEdit: rc.addTagForEdit,
    onRoleCompositionChange: rc.onRoleCompositionChange,
  }), [
    rc.ageValues,
    rc.weightValues,
    rc.minFeet, rc.minInches, rc.maxFeet, rc.maxInches,
    rc.selectedGender, rc.selectedEthnicity,
    rc.selectedEyeColor, rc.selectedHairColor,
    rc.roleCompTags,
    showEditIcon,
  ]);

  const roleCompositionContent = (
    <List
      className="w-full"
      itemLayout="horizontal"
      dataSource={roleCompositionData}
      renderItem={(item) => (
        <List.Item>
          <Popover
            placement="rightTop"
            content={item.description}
            arrow={false}
            trigger="click"
            overlayClassName="role-composition-data-popover"
            open={rc.showCompositionPopover === item.title}
            onOpenChange={(status) =>
              rc.setShowCompositionPopover(status ? item.title : null)
            }
            afterOpenChange={(status) => {
              if (!status && !showEditIcon) rc.clearMemoryLeak(item.person_attribute_uuid);
            }}
          >
            <List.Item.Meta title={<span>{item.title}</span>} />
            <div className="float-right">
              <CaretRightOutlined className="align-baseline text-[#D9D9D9] text-[11px]" />
            </div>
          </Popover>
        </List.Item>
      )}
    />
  );

  return (
    <fieldset className="w-full text-lg col-span-5">
      <RoleCompositionTrigger
        roleCompTemp={roleCompTemp}
        roleCompTags={rc.roleCompTags}
        showEditIcon={showEditIcon}
        isEditable={rc.isEditable}
        popoverContent={roleCompositionContent}
        popoverOpen={rc.showCompositionParent}
        onPopoverOpenChange={(status) => {
          if (status) {
            rc.setShowCompositionParent(true);
          } else if (!status && !showEditIcon) {
            rc.setShowCompositionPopover(false);
            setTimeout(() => rc.setShowCompositionParent(false), 300);
          }
        }}
        onTriggerClick={(e) => {
          if (showEditIcon) {
            if (!rc.isEditable) rc.setIsEditable(true);
            rc.setShowCompositionParent(true);
            e.stopPropagation();
          }
        }}
        onTagClose={(e, comp) => {
          if (showEditIcon) {
            rc.setIsEditable(true);
            rc.setShowCompositionParent(true);
            e.stopPropagation();
          }
          rc.onCloseRoleCompTag(comp);
        }}
        onSave={(e) => {
          e.stopPropagation();
          rc.setIsEditable(false);
          rc.setShowCompositionPopover(false);
          setTimeout(() => rc.setShowCompositionParent(false), 300);
          rc.onSaveEdit();
        }}
        onCancel={(e) => {
          e.stopPropagation();
          rc.setIsEditable(false);
          rc.setShowCompositionPopover(false);
          setTimeout(() => rc.setShowCompositionParent(false), 300);
          rc.updateRoleCompTemplate();
        }}
      />
    </fieldset>
  );
};

const mapDispatchToProps = { 
  triggerUpdateShiftComp: updateRoleCompositionTemplate
};

export default connect(null, mapDispatchToProps)(RoleComposition);
